// Dados dos 20 templates especializados para download de planilha modelo
// Cada row segue o formato: [Fase, Percentual(%), Cor, Etapa, Atividade, Peso(1-5), Duração(dias), Dependências]

export type TemplateRow = [string, number, string, string, string, number, number, string]

export interface SinapiMapping {
  sinapiCodigo: string
  areaTipo: 'PISO' | 'PAREDE_LIQ' | 'PAREDE_BRUTA' | 'TETO' | 'PERIMETRO' | 'MANUAL'
  tags?: string[]
  padrao?: boolean
}

export interface TemplateModel {
  key: string
  label: string
  category: string
  description: string
  rows: TemplateRow[]
  sinapiMap?: Record<string, SinapiMapping>
}

export const TEMPLATE_CATEGORIES = [
  'Construção Nova',
  'Reforma',
  'Instalações Especializadas',
  'Acabamento e Serviços',
] as const

export const TEMPLATE_MODELS: TemplateModel[] = [
  // ═══════════════════════════════════════════════════════════════
  // CONSTRUÇÃO NOVA
  // ═══════════════════════════════════════════════════════════════
  {
    key: 'casa-terrea',
    label: 'Casa Térrea',
    category: 'Construção Nova',
    description: 'Template completo para construção de casa térrea residencial',
    rows: [
      ['Fundação', 15, '#8B4513', 'Terraplanagem', 'Limpeza do terreno', 1, 2, ''],
      ['Fundação', 15, '#8B4513', 'Terraplanagem', 'Escavação', 2, 3, 'Limpeza do terreno'],
      ['Fundação', 15, '#8B4513', 'Infraestrutura', 'Estacas / Sapatas', 4, 8, 'Escavação'],
      ['Fundação', 15, '#8B4513', 'Infraestrutura', 'Baldrame', 3, 6, 'Estacas / Sapatas'],
      ['Estrutura', 20, '#3498DB', 'Alvenaria', 'Levantamento de paredes', 4, 15, 'Baldrame'],
      ['Estrutura', 20, '#3498DB', 'Alvenaria', 'Vergas e contravergas', 2, 4, 'Levantamento de paredes'],
      ['Estrutura', 20, '#3498DB', 'Cobertura', 'Estrutura do telhado', 3, 7, 'Vergas e contravergas'],
      ['Estrutura', 20, '#3498DB', 'Cobertura', 'Telhas', 2, 4, 'Estrutura do telhado'],
      ['Instalações', 20, '#9B59B6', 'Elétrica', 'Tubulação e fiação', 3, 8, 'Levantamento de paredes'],
      ['Instalações', 20, '#9B59B6', 'Elétrica', 'Quadro e disjuntores', 2, 2, 'Tubulação e fiação'],
      ['Instalações', 20, '#9B59B6', 'Hidráulica', 'Água fria e quente', 3, 6, 'Levantamento de paredes'],
      ['Instalações', 20, '#9B59B6', 'Hidráulica', 'Esgoto e drenagem', 3, 5, 'Levantamento de paredes'],
      ['Acabamento', 30, '#2ECC71', 'Revestimento', 'Chapisco e reboco', 3, 10, 'Tubulação e fiação'],
      ['Acabamento', 30, '#2ECC71', 'Revestimento', 'Cerâmica (pisos)', 4, 8, 'Chapisco e reboco'],
      ['Acabamento', 30, '#2ECC71', 'Revestimento', 'Cerâmica (paredes)', 3, 6, 'Chapisco e reboco'],
      ['Acabamento', 30, '#2ECC71', 'Pintura', 'Massa corrida', 2, 5, 'Chapisco e reboco'],
      ['Acabamento', 30, '#2ECC71', 'Pintura', 'Pintura final', 3, 5, 'Massa corrida'],
      ['Acabamento', 30, '#2ECC71', 'Louças e Metais', 'Instalação de louças', 2, 3, 'Cerâmica (paredes)'],
      ['Acabamento', 30, '#2ECC71', 'Esquadrias', 'Portas e janelas', 3, 5, 'Pintura final'],
      ['Limpeza Final', 15, '#F39C12', 'Finalização', 'Limpeza geral', 1, 2, 'Portas e janelas'],
      ['Limpeza Final', 15, '#F39C12', 'Finalização', 'Paisagismo básico', 1, 3, 'Limpeza geral'],
    ],
    sinapiMap: {
      'Escavação': { sinapiCodigo: '93358', areaTipo: 'MANUAL' },
      'Estacas / Sapatas': { sinapiCodigo: '101174', areaTipo: 'MANUAL' },
      'Baldrame': { sinapiCodigo: '96555', areaTipo: 'MANUAL' },
      'Levantamento de paredes': { sinapiCodigo: '103324', areaTipo: 'PAREDE_LIQ' },
      'Vergas e contravergas': { sinapiCodigo: '105021', areaTipo: 'MANUAL' },
      'Estrutura do telhado': { sinapiCodigo: '92543', areaTipo: 'TETO' },
      'Telhas': { sinapiCodigo: '94218', areaTipo: 'TETO' },
      'Tubulação e fiação': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Quadro e disjuntores': { sinapiCodigo: '91953', areaTipo: 'MANUAL' },
      'Água fria e quente': { sinapiCodigo: '89356', areaTipo: 'MANUAL' },
      'Esgoto e drenagem': { sinapiCodigo: '89707', areaTipo: 'MANUAL' },
      'Chapisco e reboco': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Cerâmica (pisos)': { sinapiCodigo: '87263', areaTipo: 'PISO' },
      'Cerâmica (paredes)': { sinapiCodigo: '87265', areaTipo: 'PAREDE_LIQ', tags: ['AREA_MOLHADA'] },
      'Massa corrida': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Pintura final': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Instalação de louças': { sinapiCodigo: '86888', areaTipo: 'MANUAL' },
      'Portas e janelas': { sinapiCodigo: '100681', areaTipo: 'MANUAL' },
    },
  },
  {
    key: 'sobrado',
    label: 'Sobrado',
    category: 'Construção Nova',
    description: 'Template para construção de sobrado (2 pavimentos)',
    rows: [
      ['Fundação', 12, '#8B4513', 'Terraplanagem', 'Limpeza e escavação', 2, 4, ''],
      ['Fundação', 12, '#8B4513', 'Infraestrutura', 'Estacas', 4, 8, 'Limpeza e escavação'],
      ['Fundação', 12, '#8B4513', 'Infraestrutura', 'Blocos e baldrame', 3, 7, 'Estacas'],
      ['Estrutura', 25, '#3498DB', 'Térreo', 'Pilares térreo', 4, 8, 'Blocos e baldrame'],
      ['Estrutura', 25, '#3498DB', 'Térreo', 'Vigas térreo', 3, 5, 'Pilares térreo'],
      ['Estrutura', 25, '#3498DB', 'Térreo', 'Laje do 1º andar', 5, 5, 'Vigas térreo'],
      ['Estrutura', 25, '#3498DB', 'Superior', 'Pilares superior', 4, 6, 'Laje do 1º andar'],
      ['Estrutura', 25, '#3498DB', 'Superior', 'Vigas superior', 3, 4, 'Pilares superior'],
      ['Estrutura', 25, '#3498DB', 'Superior', 'Laje de cobertura', 5, 5, 'Vigas superior'],
      ['Alvenaria', 13, '#E67E22', 'Paredes', 'Alvenaria térreo', 3, 10, 'Laje do 1º andar'],
      ['Alvenaria', 13, '#E67E22', 'Paredes', 'Alvenaria superior', 3, 10, 'Laje de cobertura'],
      ['Cobertura', 8, '#C0392B', 'Telhado', 'Estrutura do telhado', 3, 5, 'Laje de cobertura'],
      ['Cobertura', 8, '#C0392B', 'Telhado', 'Telhas e calhas', 2, 4, 'Estrutura do telhado'],
      ['Instalações', 12, '#9B59B6', 'Elétrica', 'Tubulação e fiação', 3, 10, 'Alvenaria superior'],
      ['Instalações', 12, '#9B59B6', 'Hidráulica', 'Água e esgoto', 3, 8, 'Alvenaria superior'],
      ['Acabamento', 25, '#2ECC71', 'Revestimento', 'Reboco interno', 3, 12, 'Tubulação e fiação'],
      ['Acabamento', 25, '#2ECC71', 'Revestimento', 'Pisos', 4, 10, 'Reboco interno'],
      ['Acabamento', 25, '#2ECC71', 'Pintura', 'Massa e pintura', 3, 10, 'Reboco interno'],
      ['Acabamento', 25, '#2ECC71', 'Esquadrias', 'Portas e janelas', 3, 6, 'Massa e pintura'],
      ['Acabamento', 25, '#2ECC71', 'Escada', 'Revestimento da escada', 2, 4, 'Pisos'],
      ['Finalização', 5, '#F39C12', 'Limpeza', 'Limpeza e entrega', 1, 3, 'Portas e janelas'],
    ],
    sinapiMap: {
      'Limpeza e escavação': { sinapiCodigo: '93358', areaTipo: 'MANUAL' },
      'Estacas': { sinapiCodigo: '101174', areaTipo: 'MANUAL' },
      'Blocos e baldrame': { sinapiCodigo: '96555', areaTipo: 'MANUAL' },
      'Pilares térreo': { sinapiCodigo: '103672', areaTipo: 'MANUAL' },
      'Vigas térreo': { sinapiCodigo: '103674', areaTipo: 'MANUAL' },
      'Laje do 1º andar': { sinapiCodigo: '101947', areaTipo: 'TETO' },
      'Pilares superior': { sinapiCodigo: '103672', areaTipo: 'MANUAL' },
      'Vigas superior': { sinapiCodigo: '103674', areaTipo: 'MANUAL' },
      'Laje de cobertura': { sinapiCodigo: '101947', areaTipo: 'TETO' },
      'Alvenaria térreo': { sinapiCodigo: '103324', areaTipo: 'PAREDE_LIQ' },
      'Alvenaria superior': { sinapiCodigo: '103324', areaTipo: 'PAREDE_LIQ' },
      'Estrutura do telhado': { sinapiCodigo: '92543', areaTipo: 'TETO' },
      'Telhas e calhas': { sinapiCodigo: '94218', areaTipo: 'TETO' },
      'Tubulação e fiação': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Água e esgoto': { sinapiCodigo: '89356', areaTipo: 'MANUAL' },
      'Reboco interno': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Pisos': { sinapiCodigo: '87263', areaTipo: 'PISO' },
      'Massa e pintura': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Portas e janelas': { sinapiCodigo: '100681', areaTipo: 'MANUAL' },
      'Revestimento da escada': { sinapiCodigo: '87263', areaTipo: 'PISO' },
    },
  },
  {
    key: 'apartamento-edificio',
    label: 'Apartamento (Edifício)',
    category: 'Construção Nova',
    description: 'Template para construção de edifício de apartamentos',
    rows: [
      ['Fundação', 10, '#8B4513', 'Terraplanagem', 'Escavação e contenção', 4, 15, ''],
      ['Fundação', 10, '#8B4513', 'Infraestrutura', 'Estacas / Tubulões', 5, 20, 'Escavação e contenção'],
      ['Fundação', 10, '#8B4513', 'Infraestrutura', 'Blocos de coroamento', 4, 10, 'Estacas / Tubulões'],
      ['Estrutura', 25, '#3498DB', 'Subsolo', 'Estrutura do subsolo', 5, 15, 'Blocos de coroamento'],
      ['Estrutura', 25, '#3498DB', 'Pavimentos', 'Formas e armação (tipo)', 5, 30, 'Estrutura do subsolo'],
      ['Estrutura', 25, '#3498DB', 'Pavimentos', 'Concretagem (tipo)', 5, 25, 'Formas e armação (tipo)'],
      ['Estrutura', 25, '#3498DB', 'Cobertura', 'Laje de cobertura', 4, 8, 'Concretagem (tipo)'],
      ['Alvenaria', 10, '#E67E22', 'Vedação', 'Alvenaria dos pavimentos', 4, 30, 'Concretagem (tipo)'],
      ['Instalações', 15, '#9B59B6', 'Elétrica', 'Infraestrutura elétrica', 4, 20, 'Alvenaria dos pavimentos'],
      ['Instalações', 15, '#9B59B6', 'Hidráulica', 'Prumadas e ramais', 4, 18, 'Alvenaria dos pavimentos'],
      ['Instalações', 15, '#9B59B6', 'Gás', 'Instalação de gás', 3, 10, 'Alvenaria dos pavimentos'],
      ['Instalações', 15, '#9B59B6', 'Elevador', 'Instalação do elevador', 4, 15, 'Concretagem (tipo)'],
      ['Acabamento', 25, '#2ECC71', 'Revestimento', 'Reboco e gesso', 4, 25, 'Infraestrutura elétrica'],
      ['Acabamento', 25, '#2ECC71', 'Revestimento', 'Pisos e azulejos', 4, 20, 'Reboco e gesso'],
      ['Acabamento', 25, '#2ECC71', 'Fachada', 'Revestimento externo', 4, 20, 'Reboco e gesso'],
      ['Acabamento', 25, '#2ECC71', 'Pintura', 'Pintura interna', 3, 15, 'Pisos e azulejos'],
      ['Acabamento', 25, '#2ECC71', 'Pintura', 'Pintura externa', 3, 10, 'Revestimento externo'],
      ['Acabamento', 25, '#2ECC71', 'Esquadrias', 'Portas e janelas', 3, 12, 'Pintura interna'],
      ['Áreas Comuns', 10, '#F39C12', 'Hall e Lazer', 'Acabamento áreas comuns', 3, 15, 'Pintura interna'],
      ['Áreas Comuns', 10, '#F39C12', 'Paisagismo', 'Jardim e calçada', 2, 8, 'Acabamento áreas comuns'],
      ['Finalização', 5, '#1ABC9C', 'Entrega', 'Limpeza e vistoria', 2, 5, 'Portas e janelas'],
    ],
    sinapiMap: {
      'Escavação e contenção': { sinapiCodigo: '93358', areaTipo: 'MANUAL' },
      'Estacas / Tubulões': { sinapiCodigo: '100651', areaTipo: 'MANUAL' },
      'Blocos de coroamento': { sinapiCodigo: '96555', areaTipo: 'MANUAL' },
      'Estrutura do subsolo': { sinapiCodigo: '103672', areaTipo: 'MANUAL' },
      'Concretagem (tipo)': { sinapiCodigo: '103675', areaTipo: 'MANUAL' },
      'Laje de cobertura': { sinapiCodigo: '101947', areaTipo: 'TETO' },
      'Alvenaria dos pavimentos': { sinapiCodigo: '103324', areaTipo: 'PAREDE_LIQ' },
      'Infraestrutura elétrica': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Prumadas e ramais': { sinapiCodigo: '89449', areaTipo: 'MANUAL' },
      'Reboco e gesso': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Pisos e azulejos': { sinapiCodigo: '87263', areaTipo: 'PISO' },
      'Revestimento externo': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Pintura interna': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Pintura externa': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Portas e janelas': { sinapiCodigo: '100681', areaTipo: 'MANUAL' },
    },
  },
  {
    key: 'condominio-casas',
    label: 'Condomínio de Casas',
    category: 'Construção Nova',
    description: 'Template para condomínio horizontal de casas',
    rows: [
      ['Infraestrutura', 15, '#8B4513', 'Terraplanagem', 'Terraplenagem geral', 3, 10, ''],
      ['Infraestrutura', 15, '#8B4513', 'Urbanização', 'Ruas e pavimentação', 4, 15, 'Terraplenagem geral'],
      ['Infraestrutura', 15, '#8B4513', 'Urbanização', 'Rede de água e esgoto', 4, 12, 'Terraplenagem geral'],
      ['Infraestrutura', 15, '#8B4513', 'Urbanização', 'Rede elétrica', 3, 8, 'Terraplenagem geral'],
      ['Fundação', 12, '#A0522D', 'Base', 'Fundação das unidades', 4, 15, 'Ruas e pavimentação'],
      ['Estrutura', 20, '#3498DB', 'Alvenaria', 'Paredes das unidades', 4, 25, 'Fundação das unidades'],
      ['Estrutura', 20, '#3498DB', 'Cobertura', 'Telhado das unidades', 3, 12, 'Paredes das unidades'],
      ['Instalações', 13, '#9B59B6', 'Elétrica', 'Instalação elétrica', 3, 12, 'Paredes das unidades'],
      ['Instalações', 13, '#9B59B6', 'Hidráulica', 'Instalação hidráulica', 3, 10, 'Paredes das unidades'],
      ['Acabamento', 20, '#2ECC71', 'Revestimento', 'Reboco e pisos', 4, 18, 'Instalação elétrica'],
      ['Acabamento', 20, '#2ECC71', 'Pintura', 'Pintura das unidades', 3, 10, 'Reboco e pisos'],
      ['Acabamento', 20, '#2ECC71', 'Esquadrias', 'Portas e janelas', 3, 8, 'Pintura das unidades'],
      ['Áreas Comuns', 12, '#F39C12', 'Lazer', 'Salão de festas', 3, 12, 'Ruas e pavimentação'],
      ['Áreas Comuns', 12, '#F39C12', 'Lazer', 'Playground e quadra', 2, 8, 'Ruas e pavimentação'],
      ['Áreas Comuns', 12, '#F39C12', 'Segurança', 'Portaria e muros', 3, 10, 'Ruas e pavimentação'],
      ['Finalização', 8, '#1ABC9C', 'Paisagismo', 'Jardins e calçadas', 2, 8, 'Portas e janelas'],
      ['Finalização', 8, '#1ABC9C', 'Entrega', 'Limpeza e vistoria', 1, 5, 'Jardins e calçadas'],
    ],
    sinapiMap: {
      'Fundação das unidades': { sinapiCodigo: '96555', areaTipo: 'MANUAL' },
      'Paredes das unidades': { sinapiCodigo: '103324', areaTipo: 'PAREDE_LIQ' },
      'Telhado das unidades': { sinapiCodigo: '92543', areaTipo: 'TETO' },
      'Instalação elétrica': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Instalação hidráulica': { sinapiCodigo: '89356', areaTipo: 'MANUAL' },
      'Reboco e pisos': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Pintura das unidades': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Portas e janelas': { sinapiCodigo: '100681', areaTipo: 'MANUAL' },
    },
  },
  {
    key: 'condominio-apartamentos',
    label: 'Condomínio de Apartamentos (Blocos)',
    category: 'Construção Nova',
    description: 'Template para condomínio de blocos de apartamentos',
    rows: [
      ['Infraestrutura', 12, '#8B4513', 'Terraplanagem', 'Terraplenagem e contenções', 4, 12, ''],
      ['Infraestrutura', 12, '#8B4513', 'Urbanização', 'Arruamento e redes', 4, 15, 'Terraplenagem e contenções'],
      ['Fundação', 10, '#A0522D', 'Base', 'Fundação dos blocos', 5, 20, 'Arruamento e redes'],
      ['Estrutura', 22, '#3498DB', 'Concreto', 'Estrutura dos blocos', 5, 40, 'Fundação dos blocos'],
      ['Alvenaria', 10, '#E67E22', 'Vedação', 'Alvenaria dos blocos', 4, 25, 'Estrutura dos blocos'],
      ['Instalações', 12, '#9B59B6', 'Elétrica', 'Instalação elétrica', 4, 18, 'Alvenaria dos blocos'],
      ['Instalações', 12, '#9B59B6', 'Hidráulica', 'Água, esgoto e gás', 4, 15, 'Alvenaria dos blocos'],
      ['Acabamento', 18, '#2ECC71', 'Revestimento', 'Reboco e contrapiso', 4, 20, 'Instalação elétrica'],
      ['Acabamento', 18, '#2ECC71', 'Revestimento', 'Pisos e azulejos', 4, 18, 'Reboco e contrapiso'],
      ['Acabamento', 18, '#2ECC71', 'Fachada', 'Revestimento de fachada', 3, 15, 'Reboco e contrapiso'],
      ['Acabamento', 18, '#2ECC71', 'Pintura', 'Pintura interna e externa', 3, 12, 'Pisos e azulejos'],
      ['Acabamento', 18, '#2ECC71', 'Esquadrias', 'Portas e janelas', 3, 10, 'Pintura interna e externa'],
      ['Áreas Comuns', 10, '#F39C12', 'Lazer', 'Piscina e churrasqueira', 3, 15, 'Arruamento e redes'],
      ['Áreas Comuns', 10, '#F39C12', 'Lazer', 'Salão e playground', 2, 10, 'Arruamento e redes'],
      ['Áreas Comuns', 10, '#F39C12', 'Segurança', 'Portaria e guarita', 3, 10, 'Arruamento e redes'],
      ['Finalização', 6, '#1ABC9C', 'Paisagismo', 'Jardins e iluminação', 2, 8, 'Esquadrias'],
      ['Finalização', 6, '#1ABC9C', 'Entrega', 'Limpeza e habite-se', 2, 5, 'Jardins e iluminação'],
    ],
    sinapiMap: {
      'Fundação dos blocos': { sinapiCodigo: '96555', areaTipo: 'MANUAL' },
      'Estrutura dos blocos': { sinapiCodigo: '103672', areaTipo: 'MANUAL' },
      'Alvenaria dos blocos': { sinapiCodigo: '103324', areaTipo: 'PAREDE_LIQ' },
      'Instalação elétrica': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Reboco e contrapiso': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Pisos e azulejos': { sinapiCodigo: '87263', areaTipo: 'PISO' },
      'Revestimento de fachada': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Pintura interna e externa': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Portas e janelas': { sinapiCodigo: '100681', areaTipo: 'MANUAL' },
    },
  },
  {
    key: 'galpao-barracao',
    label: 'Galpão / Barracão',
    category: 'Construção Nova',
    description: 'Template para construção de galpão industrial ou comercial',
    rows: [
      ['Fundação', 15, '#8B4513', 'Terraplanagem', 'Terraplenagem e compactação', 3, 5, ''],
      ['Fundação', 15, '#8B4513', 'Infraestrutura', 'Sapatas e blocos', 4, 8, 'Terraplenagem e compactação'],
      ['Fundação', 15, '#8B4513', 'Infraestrutura', 'Piso industrial', 4, 7, 'Sapatas e blocos'],
      ['Estrutura', 30, '#3498DB', 'Metálica', 'Pilares metálicos', 5, 8, 'Sapatas e blocos'],
      ['Estrutura', 30, '#3498DB', 'Metálica', 'Tesouras e terças', 4, 6, 'Pilares metálicos'],
      ['Estrutura', 30, '#3498DB', 'Cobertura', 'Telhas e rufos', 3, 5, 'Tesouras e terças'],
      ['Estrutura', 30, '#3498DB', 'Fechamento', 'Fechamento lateral', 3, 6, 'Tesouras e terças'],
      ['Instalações', 20, '#9B59B6', 'Elétrica', 'Infraestrutura elétrica', 4, 8, 'Fechamento lateral'],
      ['Instalações', 20, '#9B59B6', 'Elétrica', 'Iluminação industrial', 3, 5, 'Infraestrutura elétrica'],
      ['Instalações', 20, '#9B59B6', 'Hidráulica', 'Água e esgoto', 2, 5, 'Fechamento lateral'],
      ['Instalações', 20, '#9B59B6', 'Drenagem', 'Drenagem pluvial', 2, 4, 'Piso industrial'],
      ['Acabamento', 20, '#2ECC71', 'Administrativo', 'Escritórios e banheiros', 3, 10, 'Fechamento lateral'],
      ['Acabamento', 20, '#2ECC71', 'Portões', 'Portões e acessos', 3, 4, 'Fechamento lateral'],
      ['Acabamento', 20, '#2ECC71', 'Pintura', 'Pintura e sinalização', 2, 5, 'Escritórios e banheiros'],
      ['Finalização', 15, '#F39C12', 'Externo', 'Pátio e estacionamento', 3, 6, 'Portões e acessos'],
      ['Finalização', 15, '#F39C12', 'Entrega', 'Limpeza e entrega', 1, 2, 'Pátio e estacionamento'],
    ],
    sinapiMap: {
      'Sapatas e blocos': { sinapiCodigo: '96555', areaTipo: 'MANUAL' },
      'Piso industrial': { sinapiCodigo: '87620', areaTipo: 'PISO' },
      'Telhas e rufos': { sinapiCodigo: '94218', areaTipo: 'TETO' },
      'Infraestrutura elétrica': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Pintura e sinalização': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
    },
  },
  {
    key: 'loja-sala-comercial',
    label: 'Loja / Sala Comercial',
    category: 'Construção Nova',
    description: 'Template para construção ou adequação de ponto comercial',
    rows: [
      ['Fundação', 12, '#8B4513', 'Base', 'Fundação e contrapiso', 3, 6, ''],
      ['Estrutura', 20, '#3498DB', 'Alvenaria', 'Paredes e divisórias', 3, 8, 'Fundação e contrapiso'],
      ['Estrutura', 20, '#3498DB', 'Cobertura', 'Laje / Forro', 3, 5, 'Paredes e divisórias'],
      ['Estrutura', 20, '#3498DB', 'Fachada', 'Fachada comercial', 4, 7, 'Paredes e divisórias'],
      ['Instalações', 20, '#9B59B6', 'Elétrica', 'Quadro e circuitos', 3, 6, 'Paredes e divisórias'],
      ['Instalações', 20, '#9B59B6', 'Hidráulica', 'Banheiro e copa', 2, 4, 'Paredes e divisórias'],
      ['Instalações', 20, '#9B59B6', 'Climatização', 'Ar condicionado', 3, 4, 'Laje / Forro'],
      ['Acabamento', 30, '#2ECC71', 'Revestimento', 'Piso comercial', 4, 5, 'Quadro e circuitos'],
      ['Acabamento', 30, '#2ECC71', 'Revestimento', 'Revestimento de paredes', 3, 5, 'Piso comercial'],
      ['Acabamento', 30, '#2ECC71', 'Pintura', 'Pintura e acabamento', 3, 4, 'Revestimento de paredes'],
      ['Acabamento', 30, '#2ECC71', 'Vidraçaria', 'Vitrines e vidros', 3, 4, 'Fachada comercial'],
      ['Acabamento', 30, '#2ECC71', 'Esquadrias', 'Portas e fechamentos', 2, 3, 'Pintura e acabamento'],
      ['Finalização', 18, '#F39C12', 'Comunicação', 'Letreiro e identidade visual', 2, 4, 'Vitrines e vidros'],
      ['Finalização', 18, '#F39C12', 'Entrega', 'Limpeza final', 1, 1, 'Portas e fechamentos'],
    ],
    sinapiMap: {
      'Fundação e contrapiso': { sinapiCodigo: '87620', areaTipo: 'PISO' },
      'Paredes e divisórias': { sinapiCodigo: '103324', areaTipo: 'PAREDE_LIQ' },
      'Laje / Forro': { sinapiCodigo: '96109', areaTipo: 'TETO' },
      'Piso comercial': { sinapiCodigo: '87263', areaTipo: 'PISO' },
      'Revestimento de paredes': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Quadro e circuitos': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Pintura e acabamento': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Portas e fechamentos': { sinapiCodigo: '100681', areaTipo: 'MANUAL' },
    },
  },

  // ═══════════════════════════════════════════════════════════════
  // REFORMA
  // ═══════════════════════════════════════════════════════════════
  {
    key: 'reforma-interna',
    label: 'Reforma Interna',
    category: 'Reforma',
    description: 'Template para reforma interna de imóvel residencial',
    rows: [
      ['Demolição', 10, '#C0392B', 'Remoções', 'Remoção de revestimentos', 2, 3, ''],
      ['Demolição', 10, '#C0392B', 'Remoções', 'Demolição de paredes', 3, 3, ''],
      ['Demolição', 10, '#C0392B', 'Remoções', 'Retirada de entulho', 1, 2, 'Demolição de paredes'],
      ['Estrutura', 15, '#3498DB', 'Alvenaria', 'Novas paredes / drywall', 3, 5, 'Retirada de entulho'],
      ['Estrutura', 15, '#3498DB', 'Alvenaria', 'Vergas e reforços', 2, 3, 'Novas paredes / drywall'],
      ['Instalações', 20, '#9B59B6', 'Elétrica', 'Nova fiação e pontos', 3, 5, 'Novas paredes / drywall'],
      ['Instalações', 20, '#9B59B6', 'Hidráulica', 'Ajuste de tubulações', 3, 4, 'Novas paredes / drywall'],
      ['Revestimento', 25, '#E67E22', 'Paredes', 'Chapisco e reboco', 3, 6, 'Nova fiação e pontos'],
      ['Revestimento', 25, '#E67E22', 'Piso', 'Contrapiso e nivelamento', 3, 4, 'Ajuste de tubulações'],
      ['Revestimento', 25, '#E67E22', 'Piso', 'Piso cerâmico / porcelanato', 4, 6, 'Contrapiso e nivelamento'],
      ['Revestimento', 25, '#E67E22', 'Paredes', 'Azulejo (áreas molhadas)', 3, 4, 'Chapisco e reboco'],
      ['Acabamento', 25, '#2ECC71', 'Pintura', 'Massa corrida', 2, 4, 'Chapisco e reboco'],
      ['Acabamento', 25, '#2ECC71', 'Pintura', 'Pintura final', 3, 4, 'Massa corrida'],
      ['Acabamento', 25, '#2ECC71', 'Louças', 'Louças e metais', 2, 2, 'Azulejo (áreas molhadas)'],
      ['Acabamento', 25, '#2ECC71', 'Esquadrias', 'Portas e rodapés', 2, 3, 'Pintura final'],
      ['Limpeza', 5, '#F39C12', 'Final', 'Limpeza e entrega', 1, 1, 'Portas e rodapés'],
    ],
    sinapiMap: {
      'Remoção de revestimentos': { sinapiCodigo: '97634', areaTipo: 'MANUAL' },
      'Demolição de paredes': { sinapiCodigo: '97622', areaTipo: 'MANUAL' },
      'Retirada de entulho': { sinapiCodigo: '100981', areaTipo: 'MANUAL' },
      'Novas paredes / drywall': { sinapiCodigo: '104718', areaTipo: 'PAREDE_LIQ' },
      'Vergas e reforços': { sinapiCodigo: '105021', areaTipo: 'MANUAL' },
      'Nova fiação e pontos': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Ajuste de tubulações': { sinapiCodigo: '89356', areaTipo: 'MANUAL' },
      'Chapisco e reboco': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Contrapiso e nivelamento': { sinapiCodigo: '87620', areaTipo: 'PISO' },
      'Piso cerâmico / porcelanato': { sinapiCodigo: '87263', areaTipo: 'PISO' },
      'Azulejo (áreas molhadas)': { sinapiCodigo: '87265', areaTipo: 'PAREDE_LIQ', tags: ['AREA_MOLHADA'] },
      'Massa corrida': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Pintura final': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Louças e metais': { sinapiCodigo: '86888', areaTipo: 'MANUAL' },
      'Portas e rodapés': { sinapiCodigo: '100681', areaTipo: 'MANUAL' },
    },
  },
  {
    key: 'reforma-externa',
    label: 'Reforma Externa (Fachada)',
    category: 'Reforma',
    description: 'Template para reforma de fachada e áreas externas',
    rows: [
      ['Preparação', 10, '#C0392B', 'Remoções', 'Remoção de revestimento antigo', 2, 4, ''],
      ['Preparação', 10, '#C0392B', 'Remoções', 'Limpeza da superfície', 1, 2, 'Remoção de revestimento antigo'],
      ['Preparação', 10, '#C0392B', 'Segurança', 'Montagem de andaimes', 2, 2, ''],
      ['Estrutural', 15, '#3498DB', 'Reparos', 'Recuperação estrutural', 4, 6, 'Montagem de andaimes'],
      ['Estrutural', 15, '#3498DB', 'Reparos', 'Tratamento de fissuras', 3, 4, 'Recuperação estrutural'],
      ['Impermeabilização', 15, '#9B59B6', 'Proteção', 'Impermeabilização de fachada', 4, 5, 'Tratamento de fissuras'],
      ['Impermeabilização', 15, '#9B59B6', 'Proteção', 'Impermeabilização de laje', 3, 4, 'Limpeza da superfície'],
      ['Revestimento', 30, '#E67E22', 'Fachada', 'Chapisco e reboco externo', 4, 8, 'Impermeabilização de fachada'],
      ['Revestimento', 30, '#E67E22', 'Fachada', 'Textura / Cerâmica', 4, 7, 'Chapisco e reboco externo'],
      ['Revestimento', 30, '#E67E22', 'Muros', 'Revestimento de muros', 2, 4, 'Chapisco e reboco externo'],
      ['Pintura', 20, '#2ECC71', 'Externa', 'Selador e fundo', 2, 3, 'Textura / Cerâmica'],
      ['Pintura', 20, '#2ECC71', 'Externa', 'Pintura final', 3, 4, 'Selador e fundo'],
      ['Pintura', 20, '#2ECC71', 'Detalhes', 'Pintura de grades e portões', 2, 3, 'Selador e fundo'],
      ['Finalização', 10, '#F39C12', 'Acabamento', 'Desmontagem de andaimes', 1, 1, 'Pintura final'],
      ['Finalização', 10, '#F39C12', 'Acabamento', 'Limpeza geral', 1, 2, 'Desmontagem de andaimes'],
    ],
    sinapiMap: {
      'Remoção de revestimento antigo': { sinapiCodigo: '97634', areaTipo: 'MANUAL' },
      'Chapisco e reboco externo': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Revestimento de muros': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Impermeabilização de fachada': { sinapiCodigo: '98555', areaTipo: 'PISO', tags: ['AREA_MOLHADA'] },
      'Impermeabilização de laje': { sinapiCodigo: '98555', areaTipo: 'PISO', tags: ['AREA_MOLHADA'] },
      'Selador e fundo': { sinapiCodigo: '88485', areaTipo: 'PAREDE_LIQ' },
      'Pintura final': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
    },
  },
  {
    key: 'reforma-comercial',
    label: 'Reforma Comercial',
    category: 'Reforma',
    description: 'Template para reforma de espaço comercial ou escritório',
    rows: [
      ['Demolição', 10, '#C0392B', 'Remoções', 'Demolição e remoções', 3, 4, ''],
      ['Demolição', 10, '#C0392B', 'Remoções', 'Retirada de entulho', 1, 2, 'Demolição e remoções'],
      ['Estrutura', 15, '#3498DB', 'Divisórias', 'Drywall / Divisórias', 3, 5, 'Retirada de entulho'],
      ['Estrutura', 15, '#3498DB', 'Forro', 'Forro de gesso', 3, 4, 'Drywall / Divisórias'],
      ['Instalações', 20, '#9B59B6', 'Elétrica', 'Novo projeto elétrico', 4, 5, 'Drywall / Divisórias'],
      ['Instalações', 20, '#9B59B6', 'Dados', 'Rede lógica e CFTV', 3, 4, 'Forro de gesso'],
      ['Instalações', 20, '#9B59B6', 'Climatização', 'Ar condicionado', 3, 4, 'Forro de gesso'],
      ['Acabamento', 30, '#2ECC71', 'Piso', 'Piso vinílico / porcelanato', 4, 5, 'Novo projeto elétrico'],
      ['Acabamento', 30, '#2ECC71', 'Pintura', 'Pintura e textura', 3, 4, 'Piso vinílico / porcelanato'],
      ['Acabamento', 30, '#2ECC71', 'Banheiros', 'Reforma dos banheiros', 3, 5, 'Novo projeto elétrico'],
      ['Acabamento', 30, '#2ECC71', 'Vidraçaria', 'Divisórias de vidro', 3, 3, 'Pintura e textura'],
      ['Fachada', 15, '#E67E22', 'Visual', 'Letreiro e fachada', 3, 5, 'Pintura e textura'],
      ['Fachada', 15, '#E67E22', 'Acesso', 'Porta de entrada', 2, 2, 'Letreiro e fachada'],
      ['Limpeza', 10, '#F39C12', 'Final', 'Limpeza pós-obra', 1, 2, 'Porta de entrada'],
    ],
    sinapiMap: {
      'Demolição e remoções': { sinapiCodigo: '97622', areaTipo: 'MANUAL' },
      'Retirada de entulho': { sinapiCodigo: '100981', areaTipo: 'MANUAL' },
      'Drywall / Divisórias': { sinapiCodigo: '104718', areaTipo: 'PAREDE_LIQ' },
      'Forro de gesso': { sinapiCodigo: '96109', areaTipo: 'TETO' },
      'Novo projeto elétrico': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Piso vinílico / porcelanato': { sinapiCodigo: '87263', areaTipo: 'PISO' },
      'Pintura e textura': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
    },
  },

  // ═══════════════════════════════════════════════════════════════
  // INSTALAÇÕES ESPECIALIZADAS
  // ═══════════════════════════════════════════════════════════════
  {
    key: 'eletrica',
    label: 'Elétrica',
    category: 'Instalações Especializadas',
    description: 'Template para projeto e instalação elétrica completa',
    rows: [
      ['Projeto', 10, '#F1C40F', 'Planejamento', 'Projeto elétrico', 4, 5, ''],
      ['Projeto', 10, '#F1C40F', 'Planejamento', 'Compra de materiais', 2, 3, 'Projeto elétrico'],
      ['Infraestrutura', 30, '#E74C3C', 'Tubulação', 'Eletrodutos e caixas', 4, 6, 'Compra de materiais'],
      ['Infraestrutura', 30, '#E74C3C', 'Tubulação', 'Quadro de distribuição', 4, 2, 'Eletrodutos e caixas'],
      ['Infraestrutura', 30, '#E74C3C', 'Cabeamento', 'Fiação dos circuitos', 5, 5, 'Quadro de distribuição'],
      ['Instalação', 35, '#3498DB', 'Componentes', 'Disjuntores e proteção', 4, 2, 'Fiação dos circuitos'],
      ['Instalação', 35, '#3498DB', 'Componentes', 'Tomadas e interruptores', 3, 3, 'Fiação dos circuitos'],
      ['Instalação', 35, '#3498DB', 'Iluminação', 'Luminárias e spots', 3, 3, 'Fiação dos circuitos'],
      ['Instalação', 35, '#3498DB', 'Especial', 'Aterramento', 4, 2, 'Disjuntores e proteção'],
      ['Acabamento', 15, '#2ECC71', 'Espelhos', 'Espelhos e acabamentos', 2, 2, 'Tomadas e interruptores'],
      ['Acabamento', 15, '#2ECC71', 'Teste', 'Testes e medições', 3, 1, 'Aterramento'],
      ['Finalização', 10, '#9B59B6', 'Documentação', 'Laudo e ART', 2, 2, 'Testes e medições'],
    ],
    sinapiMap: {
      'Eletrodutos e caixas': { sinapiCodigo: '91854', areaTipo: 'MANUAL' },
      'Fiação dos circuitos': { sinapiCodigo: '91926', areaTipo: 'MANUAL' },
      'Tomadas e interruptores': { sinapiCodigo: '91947', areaTipo: 'MANUAL' },
    },
  },
  {
    key: 'hidraulica',
    label: 'Hidráulica / Encanamento',
    category: 'Instalações Especializadas',
    description: 'Template para instalação hidráulica residencial ou comercial',
    rows: [
      ['Projeto', 10, '#F1C40F', 'Planejamento', 'Projeto hidráulico', 4, 4, ''],
      ['Projeto', 10, '#F1C40F', 'Planejamento', 'Compra de materiais', 2, 3, 'Projeto hidráulico'],
      ['Água Fria', 25, '#3498DB', 'Tubulação', 'Prumadas e ramais', 4, 5, 'Compra de materiais'],
      ['Água Fria', 25, '#3498DB', 'Tubulação', 'Pontos de consumo', 3, 3, 'Prumadas e ramais'],
      ['Água Fria', 25, '#3498DB', 'Reservatório', 'Caixa d\'água e boia', 3, 2, 'Prumadas e ramais'],
      ['Água Quente', 15, '#E74C3C', 'Aquecimento', 'Tubulação de água quente', 3, 3, 'Pontos de consumo'],
      ['Água Quente', 15, '#E74C3C', 'Aquecimento', 'Aquecedor / Boiler', 3, 2, 'Tubulação de água quente'],
      ['Esgoto', 25, '#8B4513', 'Coleta', 'Ramais de esgoto', 4, 4, 'Compra de materiais'],
      ['Esgoto', 25, '#8B4513', 'Coleta', 'Caixas de inspeção', 3, 2, 'Ramais de esgoto'],
      ['Esgoto', 25, '#8B4513', 'Ventilação', 'Coluna de ventilação', 2, 2, 'Ramais de esgoto'],
      ['Drenagem', 15, '#2ECC71', 'Pluvial', 'Calhas e condutores', 3, 3, 'Compra de materiais'],
      ['Drenagem', 15, '#2ECC71', 'Pluvial', 'Caixas de drenagem', 2, 2, 'Calhas e condutores'],
      ['Finalização', 10, '#9B59B6', 'Teste', 'Teste de pressão', 3, 1, 'Pontos de consumo'],
      ['Finalização', 10, '#9B59B6', 'Louças', 'Conexão de louças e metais', 2, 2, 'Teste de pressão'],
    ],
    sinapiMap: {
      'Prumadas e ramais': { sinapiCodigo: '89449', areaTipo: 'MANUAL' },
      'Ramais de esgoto': { sinapiCodigo: '89707', areaTipo: 'MANUAL' },
      'Calhas e condutores': { sinapiCodigo: '100434', areaTipo: 'MANUAL' },
      'Conexão de louças e metais': { sinapiCodigo: '86888', areaTipo: 'MANUAL' },
    },
  },
  {
    key: 'energia-solar',
    label: 'Energia Solar',
    category: 'Instalações Especializadas',
    description: 'Template para instalação de sistema fotovoltaico',
    rows: [
      ['Projeto', 15, '#F1C40F', 'Planejamento', 'Dimensionamento do sistema', 4, 3, ''],
      ['Projeto', 15, '#F1C40F', 'Planejamento', 'Aprovação na distribuidora', 3, 10, 'Dimensionamento do sistema'],
      ['Projeto', 15, '#F1C40F', 'Compras', 'Aquisição de equipamentos', 3, 7, 'Dimensionamento do sistema'],
      ['Estrutura', 20, '#E67E22', 'Suporte', 'Reforço do telhado', 3, 3, 'Aquisição de equipamentos'],
      ['Estrutura', 20, '#E67E22', 'Suporte', 'Fixação dos trilhos', 3, 2, 'Reforço do telhado'],
      ['Instalação', 35, '#3498DB', 'Painéis', 'Montagem dos painéis', 4, 3, 'Fixação dos trilhos'],
      ['Instalação', 35, '#3498DB', 'Elétrica DC', 'Cabeamento string', 3, 2, 'Montagem dos painéis'],
      ['Instalação', 35, '#3498DB', 'Inversor', 'Instalação do inversor', 4, 1, 'Cabeamento string'],
      ['Instalação', 35, '#3498DB', 'Elétrica AC', 'Conexão ao quadro', 4, 1, 'Instalação do inversor'],
      ['Instalação', 35, '#3498DB', 'Proteção', 'DPS e aterramento', 3, 1, 'Conexão ao quadro'],
      ['Comissionamento', 20, '#2ECC71', 'Testes', 'Testes e medições', 3, 1, 'DPS e aterramento'],
      ['Comissionamento', 20, '#2ECC71', 'Concessionária', 'Vistoria e troca do medidor', 3, 10, 'Testes e medições'],
      ['Documentação', 10, '#9B59B6', 'Registro', 'Laudo e ART', 2, 2, 'Vistoria e troca do medidor'],
    ],
  },
  {
    key: 'ar-condicionado',
    label: 'Ar Condicionado / Climatização',
    category: 'Instalações Especializadas',
    description: 'Template para instalação de sistema de climatização',
    rows: [
      ['Projeto', 15, '#F1C40F', 'Planejamento', 'Projeto de climatização', 4, 4, ''],
      ['Projeto', 15, '#F1C40F', 'Compras', 'Aquisição de equipamentos', 3, 5, 'Projeto de climatização'],
      ['Infraestrutura', 25, '#3498DB', 'Civil', 'Abertura de passagens', 2, 2, 'Aquisição de equipamentos'],
      ['Infraestrutura', 25, '#3498DB', 'Elétrica', 'Circuito exclusivo', 3, 2, 'Abertura de passagens'],
      ['Infraestrutura', 25, '#3498DB', 'Dreno', 'Tubulação de dreno', 2, 2, 'Abertura de passagens'],
      ['Instalação', 35, '#E74C3C', 'Condensadora', 'Instalação da condensadora', 4, 2, 'Circuito exclusivo'],
      ['Instalação', 35, '#E74C3C', 'Evaporadora', 'Instalação da evaporadora', 4, 2, 'Tubulação de dreno'],
      ['Instalação', 35, '#E74C3C', 'Interligação', 'Tubulação frigorígena', 4, 3, 'Instalação da condensadora'],
      ['Instalação', 35, '#E74C3C', 'Interligação', 'Interligação elétrica', 3, 1, 'Tubulação frigorígena'],
      ['Acabamento', 15, '#2ECC71', 'Fechamento', 'Fechamento de forro', 2, 2, 'Instalação da evaporadora'],
      ['Acabamento', 15, '#2ECC71', 'Pintura', 'Repintura de retoques', 1, 1, 'Fechamento de forro'],
      ['Comissionamento', 10, '#9B59B6', 'Testes', 'Vácuo e carga de gás', 4, 1, 'Interligação elétrica'],
      ['Comissionamento', 10, '#9B59B6', 'Testes', 'Teste de funcionamento', 3, 1, 'Vácuo e carga de gás'],
    ],
  },

  // ═══════════════════════════════════════════════════════════════
  // ACABAMENTO E SERVIÇOS
  // ═══════════════════════════════════════════════════════════════
  {
    key: 'pintura',
    label: 'Pintura',
    category: 'Acabamento e Serviços',
    description: 'Template para serviço completo de pintura',
    rows: [
      ['Preparação', 20, '#F1C40F', 'Proteção', 'Proteção de móveis e pisos', 1, 1, ''],
      ['Preparação', 20, '#F1C40F', 'Limpeza', 'Limpeza das superfícies', 1, 1, 'Proteção de móveis e pisos'],
      ['Preparação', 20, '#F1C40F', 'Reparos', 'Correção de trincas e furos', 2, 2, 'Limpeza das superfícies'],
      ['Preparação', 20, '#F1C40F', 'Lixamento', 'Lixamento geral', 2, 2, 'Correção de trincas e furos'],
      ['Massa', 25, '#E67E22', 'Aplicação', 'Massa corrida / acrílica', 3, 3, 'Lixamento geral'],
      ['Massa', 25, '#E67E22', 'Acabamento', 'Lixamento da massa', 2, 2, 'Massa corrida / acrílica'],
      ['Pintura', 40, '#3498DB', 'Selador', 'Selador / Fundo', 2, 1, 'Lixamento da massa'],
      ['Pintura', 40, '#3498DB', 'Tinta', '1ª demão', 3, 2, 'Selador / Fundo'],
      ['Pintura', 40, '#3498DB', 'Tinta', '2ª demão', 3, 2, '1ª demão'],
      ['Pintura', 40, '#3498DB', 'Detalhes', 'Pintura de detalhes e recortes', 2, 1, '2ª demão'],
      ['Finalização', 15, '#2ECC71', 'Limpeza', 'Remoção de proteções', 1, 1, 'Pintura de detalhes e recortes'],
      ['Finalização', 15, '#2ECC71', 'Limpeza', 'Limpeza final', 1, 1, 'Remoção de proteções'],
    ],
    sinapiMap: {
      'Massa corrida / acrílica': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      'Selador / Fundo': { sinapiCodigo: '88485', areaTipo: 'PAREDE_LIQ' },
      '1ª demão': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
      '2ª demão': { sinapiCodigo: '88489', areaTipo: 'PAREDE_LIQ' },
    },
  },
  {
    key: 'paisagismo',
    label: 'Paisagismo',
    category: 'Acabamento e Serviços',
    description: 'Template para projeto de paisagismo e jardinagem',
    rows: [
      ['Projeto', 10, '#F1C40F', 'Planejamento', 'Projeto paisagístico', 3, 5, ''],
      ['Preparação', 20, '#8B4513', 'Terreno', 'Limpeza e nivelamento', 2, 3, 'Projeto paisagístico'],
      ['Preparação', 20, '#8B4513', 'Solo', 'Preparação do solo', 2, 2, 'Limpeza e nivelamento'],
      ['Infraestrutura', 20, '#3498DB', 'Irrigação', 'Sistema de irrigação', 4, 4, 'Preparação do solo'],
      ['Infraestrutura', 20, '#3498DB', 'Iluminação', 'Iluminação de jardim', 3, 3, 'Preparação do solo'],
      ['Infraestrutura', 20, '#3498DB', 'Drenagem', 'Drenagem do jardim', 2, 2, 'Preparação do solo'],
      ['Plantio', 30, '#2ECC71', 'Gramado', 'Plantio de grama', 3, 3, 'Sistema de irrigação'],
      ['Plantio', 30, '#2ECC71', 'Árvores', 'Plantio de árvores e arbustos', 3, 3, 'Sistema de irrigação'],
      ['Plantio', 30, '#2ECC71', 'Canteiros', 'Flores e forrações', 2, 2, 'Plantio de grama'],
      ['Acabamento', 20, '#E67E22', 'Caminhos', 'Pisos e caminhos', 3, 4, 'Plantio de grama'],
      ['Acabamento', 20, '#E67E22', 'Decoração', 'Pedras e vasos decorativos', 2, 2, 'Pisos e caminhos'],
      ['Acabamento', 20, '#E67E22', 'Mobiliário', 'Bancos e pergolados', 2, 3, 'Pisos e caminhos'],
    ],
  },
  {
    key: 'piscina',
    label: 'Piscina',
    category: 'Acabamento e Serviços',
    description: 'Template para construção de piscina',
    rows: [
      ['Projeto', 10, '#F1C40F', 'Planejamento', 'Projeto da piscina', 3, 4, ''],
      ['Escavação', 15, '#8B4513', 'Terreno', 'Escavação e remoção de terra', 4, 4, 'Projeto da piscina'],
      ['Estrutura', 25, '#3498DB', 'Concreto', 'Forma e armação', 4, 5, 'Escavação e remoção de terra'],
      ['Estrutura', 25, '#3498DB', 'Concreto', 'Concretagem (piso e paredes)', 5, 3, 'Forma e armação'],
      ['Hidráulica', 15, '#9B59B6', 'Tubulação', 'Tubulação e ralos', 4, 3, 'Concretagem (piso e paredes)'],
      ['Hidráulica', 15, '#9B59B6', 'Equipamentos', 'Casa de máquinas', 3, 3, 'Tubulação e ralos'],
      ['Impermeabilização', 10, '#E74C3C', 'Proteção', 'Impermeabilização interna', 5, 3, 'Tubulação e ralos'],
      ['Revestimento', 15, '#2ECC71', 'Acabamento', 'Pastilha / Azulejo', 4, 5, 'Impermeabilização interna'],
      ['Revestimento', 15, '#2ECC71', 'Borda', 'Borda e deck', 3, 4, 'Pastilha / Azulejo'],
      ['Entorno', 10, '#E67E22', 'Área', 'Piso do entorno', 2, 3, 'Borda e deck'],
      ['Entorno', 10, '#E67E22', 'Área', 'Ducha e paisagismo', 1, 2, 'Piso do entorno'],
    ],
    sinapiMap: {
      'Escavação e remoção de terra': { sinapiCodigo: '93358', areaTipo: 'MANUAL' },
      'Concretagem (piso e paredes)': { sinapiCodigo: '103675', areaTipo: 'MANUAL' },
      'Impermeabilização interna': { sinapiCodigo: '98555', areaTipo: 'PISO', tags: ['AREA_MOLHADA'] },
      'Pastilha / Azulejo': { sinapiCodigo: '87265', areaTipo: 'PAREDE_LIQ', tags: ['AREA_MOLHADA'] },
    },
  },
  {
    key: 'piso-revestimento',
    label: 'Piso e Revestimento',
    category: 'Acabamento e Serviços',
    description: 'Template para troca ou instalação de pisos e revestimentos',
    rows: [
      ['Remoção', 15, '#C0392B', 'Demolição', 'Remoção do piso antigo', 3, 3, ''],
      ['Remoção', 15, '#C0392B', 'Demolição', 'Remoção de azulejos', 2, 2, ''],
      ['Remoção', 15, '#C0392B', 'Limpeza', 'Retirada de entulho', 1, 1, 'Remoção do piso antigo'],
      ['Preparação', 20, '#E67E22', 'Base', 'Contrapiso / Nivelamento', 4, 4, 'Retirada de entulho'],
      ['Preparação', 20, '#E67E22', 'Base', 'Regularização de paredes', 3, 3, 'Remoção de azulejos'],
      ['Preparação', 20, '#E67E22', 'Impermeabilização', 'Impermeabilização áreas molhadas', 3, 2, 'Contrapiso / Nivelamento'],
      ['Assentamento', 40, '#3498DB', 'Piso', 'Porcelanato / Cerâmica (piso)', 5, 6, 'Impermeabilização áreas molhadas'],
      ['Assentamento', 40, '#3498DB', 'Paredes', 'Azulejo / Porcelanato (parede)', 4, 5, 'Regularização de paredes'],
      ['Assentamento', 40, '#3498DB', 'Rodapé', 'Rodapés', 2, 2, 'Porcelanato / Cerâmica (piso)'],
      ['Rejunte', 15, '#2ECC71', 'Acabamento', 'Rejunte de pisos', 3, 2, 'Rodapés'],
      ['Rejunte', 15, '#2ECC71', 'Acabamento', 'Rejunte de paredes', 2, 2, 'Azulejo / Porcelanato (parede)'],
      ['Limpeza', 10, '#F39C12', 'Final', 'Limpeza ácida', 2, 1, 'Rejunte de pisos'],
      ['Limpeza', 10, '#F39C12', 'Final', 'Limpeza final', 1, 1, 'Limpeza ácida'],
    ],
    sinapiMap: {
      'Remoção do piso antigo': { sinapiCodigo: '97634', areaTipo: 'MANUAL' },
      'Remoção de azulejos': { sinapiCodigo: '97634', areaTipo: 'MANUAL' },
      'Retirada de entulho': { sinapiCodigo: '100981', areaTipo: 'MANUAL' },
      'Contrapiso / Nivelamento': { sinapiCodigo: '87620', areaTipo: 'PISO' },
      'Regularização de paredes': { sinapiCodigo: '87879', areaTipo: 'PAREDE_LIQ' },
      'Impermeabilização áreas molhadas': { sinapiCodigo: '98555', areaTipo: 'PISO', tags: ['AREA_MOLHADA'] },
      'Porcelanato / Cerâmica (piso)': { sinapiCodigo: '87263', areaTipo: 'PISO' },
      'Azulejo / Porcelanato (parede)': { sinapiCodigo: '87265', areaTipo: 'PAREDE_LIQ', tags: ['AREA_MOLHADA'] },
      'Rodapés': { sinapiCodigo: '88648', areaTipo: 'PERIMETRO' },
    },
  },
  {
    key: 'telhado-cobertura',
    label: 'Telhado / Cobertura',
    category: 'Acabamento e Serviços',
    description: 'Template para construção ou troca de telhado',
    rows: [
      ['Remoção', 10, '#C0392B', 'Desmonte', 'Remoção de telhas antigas', 2, 2, ''],
      ['Remoção', 10, '#C0392B', 'Desmonte', 'Remoção de madeiramento', 3, 2, 'Remoção de telhas antigas'],
      ['Estrutura', 30, '#8B4513', 'Madeiramento', 'Tesouras / Treliças', 5, 5, 'Remoção de madeiramento'],
      ['Estrutura', 30, '#8B4513', 'Madeiramento', 'Terças e caibros', 3, 3, 'Tesouras / Treliças'],
      ['Estrutura', 30, '#8B4513', 'Madeiramento', 'Ripas', 2, 2, 'Terças e caibros'],
      ['Cobertura', 30, '#E67E22', 'Telhas', 'Manta subcobertura', 2, 1, 'Ripas'],
      ['Cobertura', 30, '#E67E22', 'Telhas', 'Assentamento de telhas', 4, 4, 'Manta subcobertura'],
      ['Cobertura', 30, '#E67E22', 'Telhas', 'Cumeeiras e espigões', 3, 2, 'Assentamento de telhas'],
      ['Complementos', 20, '#3498DB', 'Calhas', 'Calhas e rufos', 3, 3, 'Assentamento de telhas'],
      ['Complementos', 20, '#3498DB', 'Calhas', 'Condutores pluviais', 2, 2, 'Calhas e rufos'],
      ['Complementos', 20, '#3498DB', 'Acabamento', 'Arremates e vedações', 2, 2, 'Cumeeiras e espigões'],
      ['Finalização', 10, '#2ECC71', 'Limpeza', 'Limpeza e teste de estanqueidade', 2, 1, 'Arremates e vedações'],
    ],
    sinapiMap: {
      'Tesouras / Treliças': { sinapiCodigo: '92543', areaTipo: 'TETO' },
      'Terças e caibros': { sinapiCodigo: '92543', areaTipo: 'TETO' },
      'Assentamento de telhas': { sinapiCodigo: '94218', areaTipo: 'TETO' },
      'Cumeeiras e espigões': { sinapiCodigo: '94219', areaTipo: 'MANUAL' },
      'Calhas e rufos': { sinapiCodigo: '100434', areaTipo: 'MANUAL' },
      'Condutores pluviais': { sinapiCodigo: '100434', areaTipo: 'MANUAL' },
    },
  },
  {
    key: 'impermeabilizacao',
    label: 'Impermeabilização',
    category: 'Acabamento e Serviços',
    description: 'Template para serviço de impermeabilização',
    rows: [
      ['Diagnóstico', 10, '#F1C40F', 'Inspeção', 'Inspeção e mapeamento', 3, 2, ''],
      ['Diagnóstico', 10, '#F1C40F', 'Inspeção', 'Definição do sistema', 2, 1, 'Inspeção e mapeamento'],
      ['Preparação', 20, '#C0392B', 'Remoção', 'Remoção de revestimento', 3, 3, 'Definição do sistema'],
      ['Preparação', 20, '#C0392B', 'Limpeza', 'Limpeza e preparo da base', 2, 2, 'Remoção de revestimento'],
      ['Preparação', 20, '#C0392B', 'Regularização', 'Regularização e caimento', 3, 3, 'Limpeza e preparo da base'],
      ['Impermeabilização', 35, '#3498DB', 'Primer', 'Aplicação de primer', 3, 1, 'Regularização e caimento'],
      ['Impermeabilização', 35, '#3498DB', 'Membrana', '1ª camada impermeabilizante', 4, 2, 'Aplicação de primer'],
      ['Impermeabilização', 35, '#3498DB', 'Membrana', '2ª camada impermeabilizante', 4, 2, '1ª camada impermeabilizante'],
      ['Impermeabilização', 35, '#3498DB', 'Testes', 'Teste de estanqueidade', 5, 2, '2ª camada impermeabilizante'],
      ['Proteção', 20, '#2ECC71', 'Mecânica', 'Proteção mecânica', 3, 2, 'Teste de estanqueidade'],
      ['Proteção', 20, '#2ECC71', 'Mecânica', 'Camada separadora', 2, 1, 'Proteção mecânica'],
      ['Acabamento', 15, '#E67E22', 'Revestimento', 'Contrapiso e piso', 3, 3, 'Camada separadora'],
      ['Acabamento', 15, '#E67E22', 'Rejunte', 'Rejunte e acabamentos', 2, 1, 'Contrapiso e piso'],
    ],
    sinapiMap: {
      'Remoção de revestimento': { sinapiCodigo: '97634', areaTipo: 'MANUAL' },
      'Regularização e caimento': { sinapiCodigo: '87620', areaTipo: 'PISO' },
      '1ª camada impermeabilizante': { sinapiCodigo: '98555', areaTipo: 'PISO', tags: ['AREA_MOLHADA'] },
      '2ª camada impermeabilizante': { sinapiCodigo: '98555', areaTipo: 'PISO', tags: ['AREA_MOLHADA'] },
      'Teste de estanqueidade': { sinapiCodigo: '98555', areaTipo: 'PISO', tags: ['AREA_MOLHADA'] },
      'Contrapiso e piso': { sinapiCodigo: '87620', areaTipo: 'PISO' },
    },
  },
]
